import {
    BoltRounded,
    DirectionsRunRounded,
    ShutterSpeedRounded,
} from "@mui/icons-material";

export const defaultActivity = {
    duration: 60,
    intensity: "medium",
    mode: "gym",
};

// Labels are resolved at call time so they follow the active language; the
// `value` of each option is the API keyword and must never be translated.
export const getExerciseSections = (t) => [
    {
        path: "duration",
        title: t("publishPost.exercise.duration.title"),
        icon: ShutterSpeedRounded,
        allowCustom: true,
        customLabel: t("publishPost.exercise.duration.customLabel"),
        customPlaceholder: t("publishPost.exercise.duration.customPlaceholder"),
        customMax: 600,
        options: [
            {
                title: t("publishPost.exercise.duration.options.min15"),
                value: 15,
            },
            {
                title: t("publishPost.exercise.duration.options.min30"),
                value: 30,
            },
            {
                title: t("publishPost.exercise.duration.options.min45"),
                value: 45,
            },
            {
                title: t("publishPost.exercise.duration.options.hour1"),
                value: 60,
            },
        ],
    },
    {
        path: "intensity",
        title: t("publishPost.exercise.intensity.title"),
        icon: BoltRounded,
        options: [
            {
                title: t("publishPost.exercise.intensity.options.low"),
                value: "low",
            },
            {
                title: t("publishPost.exercise.intensity.options.medium"),
                value: "medium",
            },
            {
                title: t("publishPost.exercise.intensity.options.high"),
                value: "high",
            },
        ],
    },
    {
        path: "mode",
        title: t("publishPost.exercise.mode.title"),
        icon: DirectionsRunRounded,
        options: [
            { title: t("publishPost.exercise.mode.options.gym"), value: "gym" },
            {
                title: t("publishPost.exercise.mode.options.running"),
                value: "running",
            },
            {
                title: t("publishPost.exercise.mode.options.cycling"),
                value: "cycling",
            },
            {
                title: t("publishPost.exercise.mode.options.walking"),
                value: "walking",
            },
            {
                title: t("publishPost.exercise.mode.options.swimming"),
                value: "swimming",
            },
        ],
    },
];
